import vue from 'vue'
import Toast from './Toast'

const ToastConstructor = vue.extend(Toast)
function showToast(object) {
  const toastDom = new ToastConstructor({
    el: document.createElement('div'),
    data() {
      return {
        type: object.type || 'success',
        text: object.text || '成功',
        show: true
      }
    }
  })
  if (!document.querySelector('.__toast')) {
    document.body.appendChild(toastDom.$el)
    setTimeout(() => {
      toastDom.show = false
      document.body.removeChild(toastDom.$el)
    }, object.duration || 1000)
  }
}

function registerToast() {
  vue.prototype.$toast = showToast
}
export default registerToast



// WEBPACK FOOTER //
// ./src/components/Toast/index.js